import { useEffect, useState } from "react";

const useAnimationState = (startClosed = false) => {
  const [show, setShow] = useState(true);
  const [firstRender, setFirstRender] = useState(true);
  //   const handleSearchTextChange = (event) => {
  //     props.onSearch(event.target.value);
  //   }
  const [delay, setDelay] = useState(false);

  useEffect(() => {
    if (!firstRender) {
      if (show && startClosed) {
        setTimeout(() => setShow(() => false), 300);
      } else {
        setShow(true);
      }
    } else {
      setFirstRender(false);
    }
  }, [delay]);

  return { show, delay, setDelay };
};

export default useAnimationState;
